import React, { useMemo } from "react";
import Typograf from "typograf";
import styles from "./InfertilityCausesBlock.module.css";
import { ReactComponent as Infertility01Icon } from "../../images/svg/infertility01.svg";
import { ReactComponent as Infertility02Icon } from "../../images/svg/infertility02.svg";
import { ReactComponent as Infertility03Icon } from "../../images/svg/infertility03.svg";
import { ReactComponent as Infertility04Icon } from "../../images/svg/infertility04.svg";
import { ReactComponent as Infertility05Icon } from "../../images/svg/infertility05.svg";
import { ReactComponent as Infertility06Icon } from "../../images/svg/infertility06.svg";
import { ReactComponent as Infertility07Icon } from "../../images/svg/infertility07.svg";
import { ReactComponent as Infertility08Icon } from "../../images/svg/infertility08.svg";
import { ReactComponent as Infertility09Icon } from "../../images/svg/infertility09.svg";
import { ReactComponent as Infertility10Icon } from "../../images/svg/infertility10.svg";

const icons = [
  Infertility01Icon,
  Infertility02Icon,
  Infertility03Icon,
  Infertility04Icon,
  Infertility05Icon,
  Infertility06Icon,
  Infertility07Icon,
  Infertility08Icon,
  Infertility09Icon,
  Infertility10Icon,
];

const tp = new Typograf({ locale: ["ru", "en-US"] });

const items = [
  {
    id: 1,
    title: "нарушения менструального цикла",
    href: "https://altravita-ivf.ru/narusheniya-menstrualnogo-cikla.html",
  },
  {
    id: 2,
    title: "спаечные процессы и деформация маточных труб",
    href: "https://altravita-ivf.ru/patologiya-matki.html",
  },
  {
    id: 3,
    title: "врождённые аномалии репродуктивных органов",
    href: "https://altravita-ivf.ru/zhenskoe-besplodie.html",
  },
  {
    id: 4,
    title: "генитальный и экстрагенитальный эндометриоз",
    href: "https://altravita-ivf.ru/chto-takoe-endometrioz.html",
  },
  {
    id: 5,
    title: "последствия абортов и внутриматочных вмешательств",
    href: "https://altravita-ivf.ru/blog/besplodie-posle-aborta.html",
  },
  {
    id: 6,
    title: "перенесённые венерические заболевания",
    href: "https://altravita-ivf.ru/lechenie-zabolevanij-matki-i-pridatkov.html",
  },
  {
    id: 7,
    title: "эндокринные нарушения",
    href:
      "https://altravita-ivf.ru/vse-o-besplodii/zhenskoe-besplodie/109-besplodie-endokrinnoe.html",
  },
  {
    id: 8,
    title: "инфекционные, воспалительные и онкогенные процессы в матке",
    href: "https://altravita-ivf.ru/amputaciya-shejki-matki.html",
  },
  {
    id: 9,
    title:
      "синдром поликистозных яичников, бактериальный вагиноз, цитомегаловирусная инфекция",
    href: "https://altravita-ivf.ru/sindrom-polikistoznykh-yaichnikov.html",
  },
  {
    id: 10,
    title: "возрастные изменения репродуктивной функции",
    href: "https://altravita-ivf.ru/stati/besplodie-2-stepeni.html",
  },
];

const introText =
  "Бесплодие может быть мужским, женским или сочетанным. Причины трудностей с зачатием разнообразны и нередко связаны с перенесёнными заболеваниями, воспалениями, гормональными сбоями, операциями или возрастными изменениями. Именно с такими состояниями чаще всего обращаются к репродуктологу.";

const headingText = "К наиболее распространённым причинам бесплодия относятся:";

export default function InfertilityCausesBlock() {
  const typografedIntro = useMemo(
    () => tp.execute(introText),
    []
  );
  const typografedHeading = useMemo(() => tp.execute(headingText), []);
  const typografedItems = useMemo(
    () =>
      items.map((it) => ({
        ...it,
        title: tp.execute(it.title),
      })),
    []
  );

  return (
    <section className={styles.infertility_causes}>
      {/* декоративные “светящиеся круги” */}
      <div className={styles.infertility_causes_blob_left} aria-hidden="true" />
      <div className={styles.infertility_causes_blob_right} aria-hidden="true" />

      <div className={styles.infertility_causes_intro}>
        <p className={styles.infertility_causes_intro_text}>
          {typografedIntro}
        </p>
      </div>
      <h3 className={styles.infertility_causes_heading}>{typografedHeading}</h3>

      <div className={styles.infertility_causes_cards}>
        {typografedItems.map((it, index) => {
          const Icon = icons[index];
          return (
            <article key={it.id} className={styles.infertility_causes_card}>
              <a
                href={it.href}
                target="_blank"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "inherit",
                  alignItems: "inherit",
                  gap: "inherit",
                  width: "100%",
                }}
              >
                <Icon
                  className={styles.infertility_causes_card_icon}
                  aria-hidden="true"
                />
                <p className={styles.infertility_causes_card_text}>{it.title}</p>
              </a>
            </article>
          );
        })}
      </div>
    </section>
  );
}
